import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';

@Component({
  selector: 'cc-signon-table-location',
  templateUrl: './signon-table-location.component.html',
  styleUrls: ['./signon-table-location.component.scss'],
})
export class SignonTableLocationComponent {
  @Input() point;

  constructor(private readonly modalService: NgbModal, private readonly segmentService: SegmentService) {}

  logGoogleMapsUsage() {
    void EventNotifierService.notify(
      new DashpivotEvent(EventTypes.GoogleMapsRequestFromSignonTableLocation),
      this.segmentService,
    );
  }

  open(content, event) {
    event.stopPropagation();
    this.modalService.open(content, { size: 'lg' });
  }
}
